module.exports = __webpack_public_path__ + "img/1c971cee4e2d236fe56e11ebe7e5e851.jpg";